var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.089,
    height: 19.829,
    viewBox: "0 0 20.089 19.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70157",
    "data-name": "Group 70157",
    transform: "translate(-607.921 -122.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70156",
    "data-name": "Group 70156",
    transform: "translate(608.921 123.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58760",
    "data-name": "Path 58760",
    d: "M-1274,7701.56V7714.3",
    transform: "translate(1282.995 -7701.56)",
    fill: "none",
    stroke: "#3b91de",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58761",
    "data-name": "Path 58761",
    d: "M-1280.2,7710.3l5.333,5.462,5.254-5.462",
    transform: "translate(1283.958 -7702.916)",
    fill: "none",
    stroke: "#3b91de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58762",
    "data-name": "Path 58762",
    d: "M-1284.648,7716.765v4.984h18.089v-4.984",
    transform: "translate(1284.648 -7703.92)",
    fill: "none",
    stroke: "#3b91de",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.21046caf.svg";
export { ForwardRef as ReactComponent };